module.exports = __webpack_public_path__ + "img/137813-36-6.2f3844e8.png";